// extracted by mini-css-extract-plugin
export default {"table":"table_table__E4EBr","top_table":"table_top_table__sEVBx","table_fog":"table_table_fog__lZG2H","view_all_btn":"table_view_all_btn__+EcCe"};